import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ToastIconWrapper, ToastWrapper, BKJToastTextWrapper, BKJToastText, } from './BKJToastMessage.styled.js';
import { getIcon } from './BKJToastMessage.utils.js';
export function BKJToastMessage({ message, variant }) {
    const Icon = getIcon(variant);
    if (typeof message === 'string') {
        return (_jsxs(ToastWrapper, { children: [_jsx(ToastIconWrapper, { variant: variant, "aria-hidden": "true", "data-testid": "bkj-toast-icon", children: _jsx(Icon, {}) }), _jsx(BKJToastTextWrapper, { children: _jsx(BKJToastText, { children: message }) })] }));
    }
    const Component = message;
    return (_jsxs(ToastWrapper, { children: [_jsx(ToastIconWrapper, { variant: variant, "aria-hidden": "true", "data-testid": "bkj-toast-icon", children: _jsx(Icon, {}) }), _jsx(BKJToastTextWrapper, { children: _jsx(BKJToastText, { children: _jsx(Component, {}) }) })] }));
}
//# sourceMappingURL=BKJToastMessage.js.map